import { MTemplateDataResource } from "app/models/MTemplateDataResource";
import { IFRResource } from "app/resources/ifrresource";

export class MTemplateDataListResource extends IFRResource {

    templates: MTemplateDataResource[]
}
